var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewUnitNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11C3 9.89543 3.89543 9 5 9H25C26.1046 9 27 9.89543 27 11V19C27 19.5523 26.5523 20 26 20C25.4477 20 25 19.5523 25 19V11H5V31H14C14.5523 31 15 31.4477 15 32C15 32.5523 14.5523 33 14 33H5C3.89543 33 3 32.1046 3 31V11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9986 5C28.4263 5 26.0459 5.80816 24.0934 7.18449C23.642 7.50268 23.0181 7.39469 22.6999 6.94328C22.3817 6.49188 22.4897 5.86799 22.9411 5.54979C25.2198 3.94353 28.0005 3 30.9986 3C38.7305 3 44.9986 9.26801 44.9986 17C44.9986 21.1182 43.2191 24.8223 40.3903 27.3826C39.9808 27.7532 39.3484 27.7217 38.9778 27.3122C38.6072 26.9027 38.6387 26.2704 39.0482 25.8997C41.4758 23.7026 42.9986 20.5298 42.9986 17C42.9986 10.3726 37.626 5 30.9986 5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 29.268C40.3333 30.0378 40.3333 31.9623 39 32.7321L19.5 43.9904C18.1667 44.7602 16.5 43.7979 16.5 42.2583L16.5 19.7417C16.5 18.2021 18.1667 17.2398 19.5 18.0096L39 29.268ZM38 31L18.5 19.7417L18.5 42.2583L38 31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUnitNv);
export default __webpack_public_path__ + "static/media/newUnit_nv.a1f2e8af298dcbcb215c8ce942c6c467.svg";
export { ForwardRef as ReactComponent };